import { useCallback, useEffect, useState } from "react";
import { SvgCommandEdit, SvgSupprimer, SvgUser } from "./svg";
import { useChangeUserLogoMutation, useDeleteUserLogoMutation, useGetUserInfoQuery, useUpdateUserInfoMutation, useUploadUserLogoMutation } from "store/api";
import { env } from "env";
import { Upload } from "antd";
import { useAppSelector } from "store/hooks";
import useTranslation from "utils/hooks/useTranslation";
import { addNotification } from "store/componentsSlice";
import { useDispatch } from "react-redux";

const ProfilePicture: React.FC = () => {
    const { t } = useTranslation();
    const [image, setImage] = useState(null);
    const [opacity, setOpacity] = useState(0);

    const authState = useAppSelector((state) => state.auth);
    const { data: userInfo } = useGetUserInfoQuery(undefined);
    const [uploadUserLogo] = useUploadUserLogoMutation();
    const [changeUserLogo] = useChangeUserLogoMutation();
    const [deleteUserLogo] = useDeleteUserLogoMutation();
    const [updateUserInfo] = useUpdateUserInfoMutation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (image) {
            const userInfoData = { ...userInfo, imageId: (image as any)?.id, image: (image as any)?.filepath };
            updateUserInfo(userInfoData).then(() => {
                dispatch(addNotification({
                    type: 'success',
                    message: t('ACCOUNT_INFOS_SAVED'),
                }));
            });
        }
    }, [image])

    const onMouseLeave = useCallback(() => {
        setOpacity(0);
    }, [])
    const onMouseOver = useCallback(() => {
        setOpacity(90);
    }, [])

    const deleteLogo = useCallback(() => {
        deleteUserLogo({})
            .then((res: any) => {
                if (res.data === true) {
                    setImage(null);
                    dispatch(addNotification({
                        type: 'success',
                        message: t('USER_LOGO_DELETED'),
                    }));
                }
            })
    }, [setImage, deleteUserLogo])

    const onChange = useCallback(() => {

    }, [])

    const beforeUpload = useCallback((file: any) => {
        console.log(file);

        if (image) {
            changeUserLogo({ userId: authState?.profile?.id, name: file.name, file, imageId: (image as any).id })
                .then((res: any) => {
                    setImage(res.data);
                })
        } else {
            uploadUserLogo({ userId: authState?.profile?.id, name: file.name, file })
                .then((res: any) => {
                    setImage(res.data);
                })
        }

        return false;
    }, [setImage, image, authState?.profile, changeUserLogo, uploadUserLogo])


    return (
        <>
            <group data-gap="20" data-adaptive="desktop">
                <group
                    data-contain=""
                    data-shrink="no"
                    data-wrap="no"
                    data-align="center"
                    data-width="autofit"
                    data-gap="10"
                    onMouseLeave={onMouseLeave}

                >
                    <group data-width="auto" data-position="center" data-align="center" data-justify="center">
                        <group
                            data-length="160"
                            data-ratio="1:1"
                            data-align="center"
                            data-justify="center"
                            data-space="5"
                            data-gap="5"
                            data-border="inset"
                            data-radius="100"
                            onMouseOver={onMouseOver}
                        //data-border-color="border-color"

                        >
                            {/* <text data-position="absolute" data-wrap="wrap" data-text-size="12">To Do Uploader</text> */}
                            {(image || userInfo?.image) ?
                                <picture data-width="70" data-radius="100" data-svg-color="secondary"><img src={`${env.api_url}/${image ? (image as any)?.filepath : userInfo?.image}`} /></picture> :
                                <icon data-svg-size="70" data-svg-color="secondary" data-opacity="20"><SvgUser /></icon>
                            }

                        </group>
                        {(image || userInfo?.image) &&
                            <group
                                data-position="absolute"
                                data-width="auto"
                                {...(opacity === 0 ? { "data-opacity": opacity } : {})}
                            >
                                <group
                                    data-background="white"
                                    data-radius="5"
                                    data-align="center"
                                    data-justify="center"
                                    data-width="auto"
                                    data-cursor="pointer"
                                    data-interactive=""

                                    onClick={deleteLogo}
                                    data-space="10"
                                >
                                    <icon data-svg-size="20" data-svg-color="secondary" data-overflow="">
                                        <SvgSupprimer />
                                    </icon>
                                </group>
                            </group>}
                        {/* <group data-position="absolute" data-width="auto" data-length="160">
                            <Upload
                                accept="image/*"
                                style={{ height: 160, width: 160 }}
                                name="file"
                                listType="picture-circle"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${env.api_url}/file`}
                                beforeUpload={beforeUpload}
                                onChange={onChange}
                            >
                                <icon data-svg-size="40" data-svg-color="secondary" >
                                    {(image || userInfo?.image) ? <></> : <SvgCommandAdd />}
                                </icon>
                            </Upload>
                        </group> */}
                        <group
                            data-background="secondary"
                            data-radius="50"
                            data-align="center"
                            data-justify="center"
                            data-width="auto"
                            data-cursor="pointer"
                            data-interactive=""

                            //onClick={deleteLogo}
                            data-position="absolute"
                            data-bottom="5"
                            data-right="5"
                        //data-space="10"
                        >
                            <Upload
                                accept="image/*"
                                style={{ maxHeight: 40, maxWidth: 40 }}
                                name="file"
                                listType="picture-circle"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${env.api_url}/file`}
                                beforeUpload={beforeUpload}
                                onChange={onChange}
                            >
                                <icon data-svg-size="20" data-svg-color="white" data-overflow="">
                                    <SvgCommandEdit />
                                </icon>
                            </Upload>
                            {/* <icon data-svg-size="20" data-svg-color="white" data-overflow="">
                                <SvgSupprimer />
                            </icon> */}
                        </group>
                    </group>


                </group>
                <group
                    data-contain=""
                    data-shrink="no"
                    data-wrap="no"
                    data-align="center"
                    data-width="autofit"
                    data-gap="10"

                >
                    <group
                        data-length="autofit"
                        data-align="center"
                        data-height="40"
                        data-space="20"
                        data-gap="5"
                        data-wrap="no"
                        data-radius="5"
                        data-contain=""
                        data-color="main"
                    >
                        <text data-wrap="wrap" data-text-size="larger">{t("MYACCOUNT_TITLE")}</text>
                    </group>
                </group>
            </group>

            <group data-gap="20" data-adaptive="mobile">
                <group
                    data-contain=""
                    data-shrink="no"
                    data-wrap="no"
                    data-align="center"
                    data-width="autofit"
                    data-gap="10"
                    onMouseLeave={onMouseLeave}

                >
                    <group data-width="auto" data-align="center" >
                        <group
                            data-length="160"
                            data-ratio="1:1"
                            data-align="center"
                            data-justify="center"
                            data-space="5"
                            data-gap="5"
                            data-border="inset"
                            data-radius="100"
                            onMouseOver={onMouseOver}
                        //data-border-color="border-color"

                        >
                            {/* <text data-position="absolute" data-wrap="wrap" data-text-size="12">To Do Uploader</text> */}
                            {(image || userInfo?.image) ?
                                <picture data-width="70" data-radius="100" data-svg-color="secondary"><img src={`${env.api_url}/${image ? (image as any)?.filepath : userInfo?.image}`} /></picture> :
                                <icon data-svg-size="70" data-svg-color="secondary" data-opacity="20"><SvgUser /></icon>
                            }

                        </group>
                        {(image || userInfo?.image) &&
                            <group
                                data-position="absolute"
                                data-width="auto"
                                {...(opacity === 0 ? { "data-opacity": opacity } : {})}
                            >
                                <group
                                    data-background="white"
                                    data-radius="5"
                                    data-align="center"
                                    data-justify="center"
                                    data-width="auto"
                                    data-cursor="pointer"
                                    data-interactive=""

                                    onClick={deleteLogo}
                                    data-space="10"
                                >
                                    <icon data-svg-size="20" data-svg-color="secondary" data-overflow="">
                                        <SvgSupprimer />
                                    </icon>
                                </group>
                            </group>}
                        {/* <group data-position="absolute" data-width="auto" data-length="160">
                            <Upload
                                accept="image/*"
                                style={{ height: 160, width: 160 }}
                                name="file"
                                listType="picture-circle"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${env.api_url}/file`}
                                beforeUpload={beforeUpload}
                                onChange={onChange}
                            >
                                <icon data-svg-size="40" data-svg-color="secondary" >
                                    {(image || userInfo?.image) ? <></> : <SvgCommandAdd />}
                                </icon>
                            </Upload>
                        </group> */}
                        <group
                            data-background="secondary"
                            data-radius="50"
                            data-align="center"
                            data-justify="center"
                            data-width="auto"
                            data-cursor="pointer"
                            data-interactive=""

                            //onClick={deleteLogo}
                            data-position="absolute"
                            data-bottom="5"
                            data-right="5"
                        //data-space="10"
                        >
                            <Upload
                                accept="image/*"
                                style={{ maxHeight: 40, maxWidth: 40 }}
                                name="file"
                                listType="picture-circle"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${env.api_url}/file`}
                                beforeUpload={beforeUpload}
                                onChange={onChange}
                            >
                                <icon data-svg-size="20" data-svg-color="white" data-overflow="">
                                    <SvgCommandEdit />
                                </icon>
                            </Upload>
                            {/* <icon data-svg-size="20" data-svg-color="white" data-overflow="">
                                <SvgSupprimer />
                            </icon> */}
                        </group>
                    </group>


                </group>

            </group>
        </>
    )
}
export default ProfilePicture;
